module.exports = __webpack_public_path__ + "media/application/images/svgs/minimize-a0676d08a3d75b73071f53acbacd2e1f.svg";